<script>

  import { onMount } from 'svelte';
  import { loadPlayerScripts } from '../static';
  import { External } from '../../external';

  export let video;

  let videoCaptions = video?.captions || [];
  let scriptsLoaded = false;

  let setupPlayer = (videoElement) => {
    if (window.Hls.isSupported()) {
      let hslConfig = {
        //length in seconds
        maxBufferLength: 5,
        //length in seconds
        maxMaxBufferLength: 10,
        //size in bytes
        maxBufferSize: 20 * 1000 * 1000,
      };
      let hls = new window.Hls(hslConfig);
      hls.loadSource(video.videoPath);
      hls.attachMedia(videoElement);
    }
    let plyrOptions = {
      // title: videoTitle,
      settings: ['speed', 'loop']
    };
    if (videoCaptions && videoCaptions.length > 0) {
      plyrOptions.settings.push('captions');
      plyrOptions['captions'] = {
        active: true,
        language: videoCaptions[0].tag
      };
    }

    let player = new window.Plyr(videoElement, plyrOptions);

    return {
      destroy: () => {
        if (player) {
          player.destroy();
          player = null;
        }
      }
    };
  };

  onMount(() => {
    loadPlayerScripts(() => {
      scriptsLoaded = true;
    });
  });
</script>

<div style="height: 360px; width: 100%">
  {#if scriptsLoaded}
    <video controls crossorigin playsinline data-poster="{External.getFileFromBase(video.thumbnailFileBase) + video.thumbnailFileName  + '?format=webp'}" use:setupPlayer>
      {#each videoCaptions as caption}
        <track kind="captions" label="{caption.lang}" srclang="{caption.tag}" src="{caption.url}" />
      {/each}
    </video>
  {/if}
</div>
